import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../../_metronic/partials'
import {getAllFileRequests, updateAccessRequest} from '../../core/_requests'
import {useAuth} from '../../../auth'
import {NoDataPage} from '../../../resources/components/NoDataPage'
import Skeleton from 'react-loading-skeleton'
import {getFileType} from '../../../../core/_util'
import {toast} from 'react-toastify'

const QuickAction = () => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [notifications, setNotifications] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const {companyId} = useAuth()
  const [handleResponseLoader, setHandleResponseLoader] = useState(false)
  const [handleRejectLoader, setHandleRejectLoader] = useState(false)
  const [approveIndex, setApproveIndex] = useState<number>()
  const [rejectIndex, setRejectIndex] = useState<number>()

  const getAllRequests = async () => {
    if (!companyId) return
    try {
      setLoading(true)
      const {
        data: {success, data},
      } = await getAllFileRequests(companyId)
      if (success) {
        setNotifications(data)
      }
    } catch (err) {
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getAllRequests()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleResponse = async (id: any, action: any,name:string) => {
    if (!companyId) return
    try {
      if (action === 'Accept') {
        setHandleResponseLoader(true)
      }
      if (action === 'Reject') {
        setHandleRejectLoader(true)
      }

      const {
        data: {success, error},
      } = await updateAccessRequest(companyId, id, action)
      if (success) {
        if (action === 'Accept') {
          toast.success(`${name} request is accepted`)
        } else {
          toast.success(`${name} request is rejected`)
        }
        if (action === 'Reject') {
          setHandleRejectLoader(true)
        }
        getAllRequests()
      } else {
        toast.error(error)
      }
    } catch (err) {
    } finally {
      setHandleResponseLoader(false)
      setHandleRejectLoader(false)
    }
  }

  return (
    <div className='card rounded p-4 bg-white'>
      <div className='d-flex justify-content-between align-items-center w-100 px-2 mb-4'>
        <p className='text-muted m-0'>{formatMessage({id: 'Quick Action'})}</p>
      </div>
      <div className='overflow-auto mx-2' style={{height: '387px'}}>
        {loading ? (
          <div className='my-5 mx-1'>
            <div className='mb-4'>
              <Skeleton
                width={'100%'}
                height={50}
                count={5}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          </div>
        ) : notifications.length === 0 ? (
          <NoDataPage />
        ) : (
          <>
            {notifications.map((notification, index) => (
              <div
                key={index}
                className='bg-light border rounded py-2 px-2 my-3 d-md-flex justify-content-between align-items-center'
              >
                <div className=''>
                  <div className='d-flex align-items-center mb-1 gap-2'>
                    <img
                      src={getFileType(
                        notification.recordKeeperFile.recordKeeperFileVersion.fileName
                      )}
                      alt={notification.recordKeeperFile.recordKeeperFileVersion.fileName}
                      height={20}
                      width={20}
                    />
                    <div>
                      <h1 className='font-size-13 fw-normal m-0'>
                        {notification.recordKeeperFile.documentName.split('.')[0]}
                      </h1>
                    </div>
                  </div>
                  <p className='font-size-10 text-muted fw-semibold m-0 ms-1'>
                    {notification.user.firstName +
                      ' ' +
                      notification.user.lastName +
                      ' want to ' +
                      notification.type +
                      ' this file'}
                  </p>
                </div>
                <div className='d-flex gap-2'>
                  {notification?.action === 'Pending' && (
                    <>
                      <button
                        className='btn text-primary border border-primary py-2 font-size-13 fw-normal'
                        style={
                          mode === 'dark' ? {background: 'transparent'} : {background: '#F0F4FF'}
                        }
                        onClick={() => {
                          setApproveIndex(index)
                          handleResponse(notification.requestAccessId, 'Accept',notification.recordKeeperFile.documentName.split('.')[0])
                        }}
                        disabled={handleResponseLoader || handleRejectLoader}
                      >
                        {handleResponseLoader && approveIndex === index ? (
                          <span className='indicator-label font-size-13 p-0'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        ) : (
                          formatMessage({id: 'Approve'})
                        )}
                      </button>

                      <button
                        className='btn text-danger border border-danger py-2 font-size-13 fw-normal'
                        style={
                          mode === 'dark' ? {background: 'transparent'} : {background: '#FFF0F0'}
                        }
                        onClick={() => {
                          setRejectIndex(index)
                          handleResponse(notification.requestAccessId, 'Reject',notification.recordKeeperFile.documentName.split('.')[0])
                        }}
                        disabled={handleRejectLoader || handleResponseLoader}
                      >
                        {handleRejectLoader && rejectIndex === index ? (
                          <span className='indicator-label font-size-13 p-0'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        ) : (
                          formatMessage({id: 'Deny'})
                        )}
                      </button>
                    </>
                  )}
                  {notification?.action === 'Accept' && (
                    <div className='badge p-4 py-3 bg-success rounded-pill font-size-13 fw-normal border text-white'>
                      <i className='fa-solid fa-check me-2 text-white'></i>
                      {formatMessage({id: 'Approved'})}
                    </div>
                  )}
                  {notification?.action === 'Reject' && (
                    <div className='badge p-4 py-3 bg-danger rounded-pill font-size-13 fw-normal border text-white'>
                      <i className='fa-solid fa-xmark me-2 text-white'></i>
                      {formatMessage({id: 'Denied'})}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  )
}

export default QuickAction
